module.exports = __webpack_public_path__ + "static/media/logo.e7083708.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.svg
// module id = 277
// module chunks = 0